<template>
	<div style="height: 100%;">
		<div class="comp">
			<div class="L">
				<div class="LItem" :class="curNavIndex===0?'active':''" @click="changeCurNavIndex(0)">
					<div class="navLabel">{{userDetail.card_info.user_jifen}}</div>
					<div class="navLabel">
						<i class="el-icon-edit-outline" style="font-size: 20px;vertical-align: middle;" @click.stop="drawerjifenEdit_state = true;"></i>
						<i class="el-icon-view" slot="reference" style="font-size: 20px;vertical-align: middle;" @click="customRecordType=11;customRecordLinkId=userDetail._id;compCustomRecord_state=true"></i>
					</div>
				</div>
			</div>
			<div class="R">
				<div class="panel" v-show="curNavIndex===0">
					<div class="searchLine">
						<div class="searchLineL">
							<div class="searchItem" :class="curTab0NavIndex===0?'active':''" @click="changeCurTab0NavIndex(0)">
								<span>积分变动记录</span>
								<span v-if="curTab0NavIndex===0" class="searchItemActiveBar"></span>
							</div>
						</div>
						<div class="searchLineR">
							<!-- <el-input v-model="search0.keyword" @keyup.enter.native="changeSearch0" disabled placeholder="请输入关键字" style="width:200px;"></el-input> -->
							<el-button type="success"  @click="drawerYueJifenRecordAdd_state=true" style="margin-left:10px;">新增</el-button>
						</div>
					</div>
					<div class="list" v-if="$public.isNull(tableData0)" style="background-color: #fff;">
						<div style="padding-top:60px;text-align: center;">暂无数据</div>
					</div>
					<div class="list" v-else>
						<el-table :data="tableData0" >
							<el-table-column label="关联单号" width="150">
								<template slot-scope="scope">
									<div v-if="scope.row.order_num">
										<div v-for="(item,index) in scope.row.order_num.split(',')" :key="index" @click="see(item,scope.row)" class="linkText">{{item}}</div>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="日期">
								<template slot-scope="scope">
									{{$public.FTime(scope.row.create_time,'YYYY-MM-DD HH:mm:ss')}}
								</template>
							</el-table-column>
							<el-table-column label="类型" width="80">
								<template slot-scope="scope">
									<span v-if="scope.row.consume_type===1">充值</span>
									<span v-if="scope.row.consume_type===2">消费</span>
									<span v-if="scope.row.consume_type===3">退货</span>
									<span v-if="scope.row.consume_type===4">换货</span>
									<span v-if="scope.row.consume_type===5">其他</span>
									<span v-if="scope.row.consume_type===6">充值退款</span>
								</template>
							</el-table-column>
							<el-table-column label="服务地点" width="80">
								<template slot-scope="scope">
									{{scope.row.service_address}}
								</template>
							</el-table-column>
							<el-table-column label="变化值" width="110">
								<template slot-scope="scope">
									<span v-if="scope.row.type_id===1" style="color:rgb(24, 164, 76)">+{{scope.row.consume.user_jifen}}</span>
									<span v-if="scope.row.type_id===2" style="color:#FF182A">-{{scope.row.consume.user_jifen}}</span>
								</template>
							</el-table-column>
							<el-table-column label="变动后余额" width="120">
								<template slot-scope="scope">
									{{scope.row.after.user_jifen}}
								</template>
							</el-table-column>
							<el-table-column label="备注" width="100">
								<template slot-scope="scope">
									{{scope.row.remark}}
								</template>
							</el-table-column>
							<el-table-column label="操作" width="80">
								<template slot-scope="scope">
									<el-button @click="curRow=scope.row;drawerYueJifenRecordEdit_state=true" type="text" size="small">修改</el-button>
									<i class="el-icon-view" slot="reference" style="font-size: 16px;margin-left: 5px;color:#409EFF;" @click="customRecordType=3;customRecordLinkId=scope.row._id;compCustomRecord_state=true"></i>
								</template>
							</el-table-column>
						</el-table>
						<div class="pagePosi">
							<page style="padding:10px 0;" :page="page0.page" :total="page0.total" @change="changePage0"></page>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="drawerjifenEdit_state">
			<drawerjifenEdit :id="userDetail._id" :money="userDetail.card_info.user_jifen" @submit="submit_drawerjifenEdit"></drawerjifenEdit>
		</div>
		<!-- 添加资产变动记录 -->
		<div v-if="drawerYueJifenRecordAdd_state">
			<drawerYueJifenRecordAdd :type="'jifen'" :userDetail="userDetail" @submit="submit_drawerYueJifenRecordAdd"></drawerYueJifenRecordAdd>
		</div>
		<!-- 积分变动记录修改 -->
		<div v-if="drawerYueJifenRecordEdit_state">
			<drawerYueJifenRecordEdit :type="'jifen'" :row="curRow" @submit="submit_drawerYueJifenRecordEdit"></drawerYueJifenRecordEdit>
		</div>
		<!-- 自定义记录 -->
		<div v-if="compCustomRecord_state">
			<compCustomRecord :linkId="customRecordLinkId" :type="customRecordType" @submit="compCustomRecord_state=false"></compCustomRecord>
		</div>
	</div>
</template>

<script>
	import page from "@/components/page.vue"
	import drawerjifenEdit from "./drawer/drawer_jifenEdit.vue"
	import drawerYueJifenRecordAdd from "./drawer/drawer_yueJifenRecordAdd.vue"
	import drawerYueJifenRecordEdit from "./drawer/drawer_yueJifenRecordEdit.vue"
	import compCustomRecord from "@/components/compCustomRecord.vue"
	export default {
		components:{page,drawerjifenEdit,compCustomRecord,drawerYueJifenRecordEdit,drawerYueJifenRecordAdd},
		data() {
			return {
				curNavIndex:0,
				
				curTab0NavIndex:0,
				
				// 图文
				search0:{
					keyword:'',
				},
				page0:{
					page:1,
					pageSize:10,
					total:0
				},
				tableData0:[],
				// 修改余额
				drawerjifenEdit_state:false,
				// 新增余额变动记录
				drawerYueJifenRecordAdd_state:false,
				// 积分变动记录修改
				drawerYueJifenRecordEdit_state:false,
				curRow:{},
				
				// 自定义记录
				compCustomRecord_state:false,
				customRecordType:0,
				customRecordLinkId:'',
			}
		},
		props:{
			userDetail:{
				default:()=>{
					return {}
				}
			}
		},
		computed:{
			
		},
		mounted(){
			this.getRecordList()
		},
		methods:{
			// 修改积分
			submit_drawerjifenEdit(obj){
				this.drawerjifenEdit_state =false;
				if(obj.type==="success"){
					this.userDetail.card_info.user_jifen = obj.data;
					this.page0.page=1;
					this.getRecordList()
				}
			},
			// 余额变动记录 新增
			submit_drawerYueJifenRecordAdd(obj){
				this.drawerYueJifenRecordAdd_state =false;
				if(obj.type==="success"){
					this.getRecordList()
				}
			},
			// 积分变动记录修改
			submit_drawerYueJifenRecordEdit(obj){
				this.drawerYueJifenRecordEdit_state =false;
				if(obj.type==="success"){
					this.getRecordList()
				}
			},
			
			changeCurNavIndex(i){
				this.curNavIndex=i;
				if(i===0){this.getRecordList()} // 
			},
			// 
			changeSearch0(){
				this.page0.page=1;
				this.getRecordList()
			},
			changeCurTab0NavIndex(i){
				this.curTab0NavIndex=i;
				this.page0.page=1;
				this.getRecordList()
			},
			changePage0(num){
				this.page0.page=num;
				this.getRecordList()
			},
			getRecordList(){
				let params = {
					"consume_type": 0,  //  0:全部、1:充值、2:消费、3:退货、4:换货、5:其他
					"start_time": "",
					"end_time": "",
					"member_id": this.userDetail._id,
					"type": 2,  //  -1.全部 1.押金 2.积分 3.赠额 4.余额 5.抵用
					"page_index": this.page0.page,
					"page_size": this.page0.pageSize,
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_member+'/api/middleware/Member/MemberPropertyRecord', params).then(res => {
					loading.close();
					if (res.code == 0) {
						this.tableData0 = res.data.data||[];
						this.page0.total = res.data.count;
					}
				})
			},
			
		},
	}
</script>

<style lang="scss" scoped>
	.comp{
		display: flex;margin-top:16px;height: 100%;
		.L{
			width:272px;background-color: #fff;border-radius: 16px;flex-shrink: 0;padding:24px;box-sizing: border-box;margin-right: 16px;
			.LItem{
				line-height: 36px;display: flex;color:$color333;font-size: 14px;font-weight: bold;cursor: pointer;margin-bottom: 10px;
				&.active{
					color:#577BFF;background-color: #F6F8FF;
				}
				.navLabel{
					width:50%;text-align: center;
				}
				.navValue{
					width:50%;text-align: center;
				}
			}
		}
		.R{
			width:100%;
			.panel{
				position: relative;height: 100%;
				.searchLine{
					display: flex;justify-content: space-between;background-color: #fff;border-radius: 16px 16px 0px 0px;padding:20px 32px 20px;position: absolute;width:100%;box-sizing: border-box;top:0;z-index: 1;
					.searchLineL{
						display: flex;padding-top: 16px;
						.searchItem{
							font-size: 14px;color:$color333;margin-right: 40px;cursor: pointer;
							&.active{
								color:#577BFF;
							}
							.searchItemActiveBar{
								display: block;width:18px;height: 4px;background: linear-gradient(135deg, #4BB2FF 0%, #466BFF 100%);border-radius: 3px;margin:8px auto 0;
							}
						}
					}
					.searchLineR{
						
					}
				}
				.list{
					padding-top:80px;border-radius: 16px;overflow: auto;height: calc(100% - 80px);background-color: #fff;
					.item{
						background-color: #fff;border-radius: 16px;margin-bottom:16px;padding:32px;display: flex;
						.avatarBox{
							.avatar{
								width:56px;height: 56px;border-radius: 50%;margin-right: 16px;
							}
						}
						.avatarBoxR{
							.originalName{
								font-size: 14px;color:$color333;padding-bottom:5px
							}
							.originalTime{
								font-size: 12px;color:$color999;
							}
							.originalTag{
								display: flex;padding-top:10px;
								.tagItem{
									background-color: #F7F9FA;border-radius: 12px;margin-right: 20px;display: flex;height: 22px;padding:3px 10px 3px 3px;box-sizing: border-box;line-height: 16px;
									.tagIcon{
										width:16px;height: 16px;margin-right: 5px;
									}
									.tagText{
										font-size: 12px;color:#4062E7;
									}
								}
							}
							.originalWord{
								padding-top:10px;padding-right: 50px;
								.word{
									font-size: 14px;color:$color333;line-height: 22px;
								}
							}
							.originalImg{
								padding-top:10px;padding-right: 30px;overflow: hidden;white-space: nowrap;width:625px;
								.originalImgItem{
									width:104px;height: 104px;margin-right: 4px;
								}
							}
							.originalBtn{
								display: flex;padding-top:16px;
								.num1{
									font-size: 14px;color:#333;margin-right: 16px;
								}
								.num2{
									font-size: 14px;color:$color999;margin-right: 32px;
								}
								.btn{
									font-size: 14px;color:#577BFF;margin-right: 32px;cursor: pointer;
								}
							}
						}
					}
				}
				
			}
			.pagePosi{
				width:100%;text-align: right;background-color: #fff;border-radius: 8px;padding:0 10px;box-sizing: border-box;position: relative;z-index: 1;
			}
		}
	}
</style>
